"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BadgeCertificateIcon;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _isCompleted = _interopRequireDefault(require("../utils/isCompleted"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var s = {
  certBadgeIcon: function certBadgeIcon(theme, size, type) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("height:", size, "px;width:", size, "px;", type === 'certificate' ? "fill: ".concat(theme.color.dark.emerald, ";") : '')
    );
  }
};

function BadgeCertificateIcon(props) {
  var completed = (0, _isCompleted.default)(props);

  if (!completed) {
    return null;
  }

  var theme = props.theme,
      size = props.size;
  var certificateInfo = props.certificateInfo;

  if (certificateInfo) {
    return _react.default.createElement(_Icon.default, {
      className: s.certBadgeIcon(theme, size, 'certificate'),
      type: "starBig"
    });
  }

  var badgeInfo = props.badgeInfo;

  if (badgeInfo) {
    return _react.default.createElement(_Icon.default, {
      className: s.certBadgeIcon(theme, size, 'badge'),
      type: "medalBig"
    });
  }

  return null;
}